import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { EncreToneContext } from './encreToneContext';

/**
 * A surface redrawn in Encre (PLAN-ENCRE-OUTILS: the CRM sheets, the Comptes page) tells the shared
 * pieces it renders — a badge, a picker, a form line also used by tools not yet redrawn — to take
 * Encre's tokens. Elsewhere they keep their look: nothing changes until each tool is redrawn.
 * `on={false}` switches it off for a subtree.
 */
export function EncreTone({ children, on = true }: { children: ReactNode; on?: boolean }) {
  return <EncreToneContext.Provider value={on}>{children}</EncreToneContext.Provider>;
}

/**
 * A piece not redrawn yet — a modal — opened from an Encre surface: drawn outside it (in the body,
 * the tone off), so it keeps its own look whole. Inside, it inherited the surface's ink and colour
 * scheme: in the dark theme, typed text went invisible on its white card (relecture du 13/10/2026).
 */
export function LegacyLayer({ children }: { children: ReactNode }) {
  return createPortal(<EncreTone on={false}>{children}</EncreTone>, document.body);
}
